import {
  badgeRecipe
} from "./chunk-RPNIV257.mjs";
import {
  styled
} from "./chunk-CY4SMQ2L.mjs";

// src/components/badge/styled-components.ts
import { ark } from "@ark-ui/react";
var StyledBadge = styled(ark.span, badgeRecipe);

export {
  StyledBadge
};
